import React, { ReactNode } from "react";

import { Icon, Typography } from "components";

type AutomationCardProps = {
  iconName: string;
  title: string;
  children: ReactNode;
  footer?: ReactNode;
  className?: string;
  testId?: string;
};

export const AutomationCard = ({ iconName, title, children, footer, className, testId }: AutomationCardProps) => (
  <div className={`automation-card ${className ?? ""}`} data-testid={testId}>
    <div className="automation-card-title">
      <Icon iconName={iconName} size="m" className="icon" />
      <Typography variant="paragraph-m" bold>
        {title}
      </Typography>
    </div>
    {children}
    {footer && <div className="automation-card-footer">{footer}</div>}
  </div>
);
